import request from '@/utils/request'

export function getLogo() {
  return request({
    url: '/Organizations/GetLogo',
    method: 'Get'
  })
}

